import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import reportWebVitals from "./reportWebVitals";
import { initAnalytics, trackEvent } from "./utils/analytics";

initAnalytics();



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </BrowserRouter>
);

reportWebVitals((metric) => {
  trackEvent("web_vitals", {
    metric_name: metric.name,
    metric_value: metric.value,
    metric_rating: metric.rating || "unknown",
  });
});
